var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidenavExamsArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 14.1667V17.5M4.16666 6.87887C5.22147 7.04222 6.39814 7.31381 7.49999 7.7399M9.99999 5.04447V17.5C9.80037 17.5 9.60074 17.4404 9.43068 17.3212C7.66093 16.0811 5.17724 15.5192 3.3286 15.3103C2.41368 15.2069 1.66666 14.4426 1.66666 13.5V4.11265C1.66666 3.17002 2.41368 2.40601 3.3286 2.50939C5.17724 2.71829 7.66093 3.28027 9.43068 4.52037C9.77081 4.75871 10.2292 4.75871 10.5693 4.52037C12.339 3.28027 14.8227 2.71829 16.6714 2.50939C17.5863 2.40601 18.3333 3.17002 18.3333 4.11265V11.6667M4.16666 10.2122C4.69956 10.2947 5.26357 10.4049 5.83332 10.5486",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 11.6667C15.8333 12.1269 15.4602 12.5 15 12.5C14.5398 12.5 14.1667 12.1269 14.1667 11.6667C14.1667 11.2064 14.5398 10.8333 15 10.8333C15.4602 10.8333 15.8333 11.2064 15.8333 11.6667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidenavExamsArchive);
export default __webpack_public_path__ + "static/media/sidenav-exams-archive.4d1b56be7b55d1a9bdfc5b0fa42af508.svg";
export { ForwardRef as ReactComponent };